import * as React from 'react';
import EditableChipsListField from 'common/components/common/EditableChipsListField';
import { HelpTooltip } from 'common/components/core/help';

export default class ZonesInput extends React.PureComponent {
    formatCreateLabel = label => {
        const { t } = this.props;
        return `${t('entityManagement:create')} ${label}`;
    };

    getOptionLabel = zone => zone.value;

    onZonesChange = zones => {
        const { onChange } = this.props;
        onChange && onChange(zones);
        return Promise.resolve();
    };

    render() {
        const { zones, error, theme, t, label, field } = this.props;
        const { helpText } = field;
        return (
            <div className={theme.fieldGroup}>
                <span className={theme.label}>
                    {label}
                    {helpText ? (
                        <HelpTooltip tooltipText={t(helpText)} />
                    ) : null}
                </span>
                <EditableChipsListField
                    saveOnEnter={false}
                    isEditingEnabled
                    multiAutoHeight
                    isFocused
                    disableIcons
                    noHover
                    isClearable
                    hideDropdownIndicator
                    isMulti
                    options={[]}
                    disableEditIcon={!zones?.length}
                    error={error}
                    emptyStateText={t('entityManagement:riderForm.addZones')}
                    formatCreateLabel={this.formatCreateLabel}
                    placeholder={t('entityManagement:riderForm.addZones')}
                    theme={theme}
                    getOptionLabel={this.getOptionLabel}
                    value={zones}
                    customFieldClass={!zones?.length ? theme.empty : null}
                    onSave={this.onZonesChange}
                />
            </div>
        );
    }
}
